import metricStyles from './css/metricTheme.module.scss';

export const metricColour = percentage => {
    if (percentage > 1) percentage = percentage / 100;
    if (percentage === null) return 'grey';
    return percentage <= 0.2
        ? 'red'
        : percentage <= 0.4
        ? 'orange'
        : percentage <= 0.6
        ? 'yellow'
        : percentage <= 0.8
        ? 'green'
        : '';
};

export const metricHashColour = percentage => {
    if (percentage > 1) percentage = percentage / 100;
    if (percentage === null) return 'grey';
    return percentage <= 0.2
        ? metricStyles.red
        : percentage <= 0.4
        ? metricStyles.orange
        : percentage <= 0.6
        ? metricStyles.yellow
        : percentage <= 0.8
        ? metricStyles.green
        : metricStyles.blue;
};

export const getHSLFromHex = hex => {
    // 1. Convert hex to RGB
    hex = hex.replace(/^#/, '');
    if (hex.length === 3) {
        hex = hex
            .split('')
            .map(s => s + s)
            .join('');
    }

    // 2. Convert Hex to RGB (0 to 1 range)
    const r = parseInt(hex.substring(0, 2), 16) / 255;
    const g = parseInt(hex.substring(2, 4), 16) / 255;
    const b = parseInt(hex.substring(4, 6), 16) / 255;

    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const delta = max - min;

    let h = 0;
    let s = 0;
    let l = (max + min) / 2;

    // 3. Calculate Hue and Saturation
    if (delta !== 0) {
        // Saturation calculation based on Lightness
        s = l > 0.5 ? delta / (2 - max - min) : delta / (max + min);

        // Hue calculation
        if (max === r) {
            h = ((g - b) / delta) % 6;
        } else if (max === g) {
            h = (b - r) / delta + 2;
        } else {
            h = (r - g) / delta + 4;
        }

        h = Math.round(h * 60);
        if (h < 0) h += 360;
    }

    return {
        h: h,
        s: +(s * 100).toFixed(1),
        l: +(l * 100).toFixed(1)
    };
};

export const generatePalette = (count, hex) => {
    let { h: nextHue, s, l } = getHSLFromHex(hex || '#35327c');
    const hueGap = 30;
    nextHue = nextHue - hueGap;
    return Array.from({ length: count }, () => {
        nextHue = nextHue + hueGap;
        if (nextHue > 360) nextHue = 360 - nextHue;
        return `hsl(${nextHue}, ${s}%, ${l}%)`;
    });
};
